<template>
  <div>
    <el-dialog :title="text"
               :visible.sync="dialogVisible"
               v-dialogDrag
               :close-on-click-modal="false"
               :append-to-body="true"
               width="500px"
               :before-close="handleClose">
      <el-form :model="form"
               ref="formRef"
               label-width="100px"
               :rules="rules">

        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="阶段名称"
                          prop="stage_name">
              <el-input clearable
                        style="width:100%"
                        v-model="form.stage_name"
                        placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="年级:"
                          prop="grade_id">
              <el-select v-model="form.grade_id"
                         multiple
                         style="width:100%"
                         placeholder="请选择">
                <el-option v-for="item in gradeList"
                           :key="item.grade_id"
                           :label="item.grade_name "
                           :value="item.grade_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="阶段描述"
                          prop="name">
              <el-input clearable
                        style="width:100%"
                        v-model="form.desc"
                        placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="add">确 定</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      form: {},
      text: '新增',
      rules: {
        grade_id: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        stage_name: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
      },
      gradeList: [],
      dialogVisible: false,
    }
  },

  mounted () {
    this.getList()
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.$refs.formRef.resetFields()
    },
    getList () {
      this.$http({
        url: '/api/v1/school/select_grade',
        method: 'get'
      }).then(res => {
        this.gradeList = res.data.list
      })
    },

    add () {
      this.$refs.formRef.validate(val => {
        if (!val) return

        this.$http({
          url: '/api/v1/study/create',
          method: 'post',
          data: this.form
        }).then(() => {
          this.$notify({
            title: '提示',
            message: '成功!',
            type: 'success'
          });
          this.handleClose()
          this.$parent.initData()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  text-align: center;
}
::v-deep .dialog-footer {
  text-align: center;
}

::v-deep .el-dialog__header {
  font-size: 20px;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4px;
}
</style>